/* HeyLight-Finanzierungszeile: ganze Zeile klickbar machen, nicht nur das Info-Icon.
   Delegiert Klicks innerhalb von .heidi_messaging auf den vom HeyLight-SDK
   gerenderten Info-Link (a[onclick*="handleClick"]), der das Raten-Modal öffnet.
   Hintergrund: Clarity zeigt Dead-Clicks auf der Zeile (CRO-Puls 30.07.2026). */
document.addEventListener('click', function (e) {
  var wrap = e.target.closest && e.target.closest('.heidi_messaging');
  if (!wrap) return;
  var trigger = wrap.querySelector('a[onclick*="handleClick"]');
  if (!trigger || trigger.contains(e.target)) return;
  e.preventDefault();
  trigger.click();
});
